import { DEFAULT_LOCATION } from '../../brands/default/config';
import { LOCATIONS } from '../../brands/default/constants';

const initialState = {
  location: DEFAULT_LOCATION,
  locations: [],
};

const locationsReducer = (
  // eslint-disable-next-line default-param-last
  state = initialState,
  { type, locations, location },
) => {
  switch (type) {
    case LOCATIONS.SET_LOCATIONS: {
      return {
        ...state,
        locations,
      };
    }
    case LOCATIONS.SET_LOCATION: {
      return {
        ...state,
        location,
      };
    }
    default:
      return state;
  }
};

export default locationsReducer;
